import { useState } from "react"
import UserTenantTable, {
  type UserTenantTableProps,
} from "@/v2-backoffice-client/user/tenant/UserTenantTable"
import { useUserTenantQuery } from "@/v2-backoffice-client/user/tenant/user.tenant.query"

export type UserTenantsProps = Omit<
  UserTenantTableProps,
  "isLoading" | "error" | "userTenants" | "onRefresh" | "onDeletedFilterChange"
> & {
  userId: number
}

function UserTenants(props: UserTenantsProps) {
  const { userId, ...userTenantTableProps } = props

  const [onlyDeleted, setOnlyDeleted] = useState<boolean | undefined>(false)

  const { data, loading, error, refetch } = useUserTenantQuery({
    variables: { userId, onlyDeleted },
  })

  const userTenants = data?.getUserTenantsByUserId ?? []

  return (
    <UserTenantTable
      userId={userId}
      isLoading={loading}
      error={error}
      userTenants={userTenants}
      onDeletedFilterChange={setOnlyDeleted}
      onRefresh={refetch}
      {...userTenantTableProps}
    />
  )
}

export default UserTenants
